// libs
import React, { memo } from "react";

// Global Components
import WithStyles from "shared/components/WithStyles";

//styles
import { navCss } from "./styles";

// def
interface INavButtonProps {
    type: "prev" | "next";
}

function NavButton({ type }: INavButtonProps) {
    return <WithStyles as="i" cssProps={navCss} className={`icon-arrow ${type}`} />;
}

export default memo(NavButton);
